var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count)?_c('div',{staticClass:"group"},_vm._l((_vm.recommendation.inputs),function(input){return _c('com-input',{key:input,attrs:{"input":_vm.inputs[input]}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }